module.exports = __webpack_public_path__ + "static/img/qrcode.358c0f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/qrcode.jpg
// module id = x88k
// module chunks = 0